import { render, staticRenderFns } from "./FareOptionsList.vue?vue&type=template&id=3553dc20&scoped=true&"
import script from "./FareOptionsList.vue?vue&type=script&lang=js&"
export * from "./FareOptionsList.vue?vue&type=script&lang=js&"
import style0 from "./FareOptionsList.vue?vue&type=style&index=0&id=3553dc20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3553dc20",
  null
  
)

export default component.exports